import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Legend,
  ResponsiveContainer,
} from "recharts";
import styled from "styled-components";
import theme from "../../theme/theme";
import { numberFormatter } from "../../utils";
import CustomizedXAxisTick from "./CustomizedXAxisTick";
import CustomLegend from "./CustomLegend";

const Wrapper = styled.div`
  .recharts-default-tooltip ul > li > span {
    font-weight: 300;
    color: black;
    font-size: 0.7em;
  }

  .xAxis .recharts-cartesian-axis-ticks > *:not(:first-child):not(:last-child) {
    display: none;
  }

  .yAxis tspan {
    font-size: 11px;
  }
`;

const PortfolioChart = ({ data, graphStartingPoint }) => {
  if (!data) return null;
  const chartData = Object.keys(data).map((key) => ({
    year: Number(new Date(key).getFullYear()),
    ...data[key],
  }));

  const YAxisFormater = (tickItem) => numberFormatter(tickItem, 1);

  return (
    <Wrapper>
      <ResponsiveContainer width="100%" aspect={3}>
        <AreaChart width={730} height={250} data={chartData}>
          <XAxis
            tickLine={false}
            dataKey="year"
            tick={<CustomizedXAxisTick />}
            interval="preserveStartEnd"
          />
          <YAxis
            tickLine={false}
            orientation="right"
            type="number"
            tickCount={100}
            domain={[
              (dataMin) => Math.max(0, dataMin - dataMin * 0.1),
              (dataMax) => dataMax + dataMax * 0.1,
            ]}
            tickFormatter={YAxisFormater}
          />
          <Area
            id="strongMarket"
            dataKey={(graphData) => [graphData["average"], graphData["strong"]]}
            stroke={theme.colors.strongMarketFill}
            strokeWidth={0}
            fill={theme.colors.strongMarketFill}
            fillOpacity={1}
          />
          <Area
            id="avgMarket"
            dataKey={(graphData) => [graphData["weak"], graphData["average"]]}
            stroke={theme.colors.avgMarket}
            strokeWidth={0}
            fill={theme.colors.avgMarket}
            fillOpacity={1}
          />
          <Area
            id="weakMarket"
            dataKey={(graphData) => [0, graphData["weak"]]}
            stroke={theme.colors.weakMarketFill}
            strokeWidth={0}
            fill={theme.colors.weakMarketFill}
            fillOpacity={1}
          />

          <Legend content={CustomLegend} verticalAlign="bottom" height={36} />
        </AreaChart>
      </ResponsiveContainer>
    </Wrapper>
  );
};

export default PortfolioChart;
